import React,{ Component } from 'react'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { guardaPago } from '../actions'
import queryString from 'query-string'

class Resp extends Component{

	constructor(props) {
	    super(props);
	    this.state = {
	      flias:[]
	    }
	}

  	componentDidMount() {

			var result=0
			var tipo = 0
			var data

  		if(this.props.location.pathname==="/success"){
				result=1
			} else if (this.props.location.pathname === "/aconfirmar") {
				result = 0
				tipo=1
  		}else if(this.props.location.pathname==="/standby"){
  			result=0
  		}else if(this.props.location.pathname==="/fail"){
  			result=3
			}
			const values = queryString.parse(this.props.location.search)
			console.log(values)
			if(tipo===1){
				data = {
					razon: "NO ES CONSUMIDOR FINAL",
					resultado: "NO SE PROCESO EL PAGO",
					external_reference: values.ref
				}
			}else{
				data = {
					collection_id:values.collection_id,
					collection_status:values.collection_status,
					preference_id:values.preference_id,
					external_reference:values.external_reference,
					payment_type:values.payment_type,
					merchant_order_id:values.merchant_order_id,
					resultado:result
				}
			}
			console.log(data)
      this.props.guardaPago(data)
  	}

  	render() {
      const values = queryString.parse(this.props.location.search)
      var msj = "AGUARDE"
      var tit = ""
      if(this.props.location.pathname==="/success"){
        tit = "FELICITACIONES!"
				msj ="EL PAGO SE PROCESO CON EXITO, SU ORDEN DE PAGO ES LA NUMERO "+values.merchant_order_id
			} else if (this.props.location.pathname === "/aconfirmar"){
				tit = "FELICITACIONES!"
				msj = "SE REALIZO CORRECTAMENTE EL PEDIDO, PONGASE EN CONTACTO CON NOSOTROS PARA COORDINAR EL PAGO Y LA FACTURACION"
      }else if(this.props.location.pathname==="/standby"){
        tit = "ALGO OCURRIO"
        msj ="EL PAGO QUEDO PENDIENTE"
      }else if(this.props.location.pathname==="/fail"){
        tit = "LO SENTIMOS"
        msj = "SE PRODUJO UN ERROR AL INTENTAR REALIZAR EL PAGO"
      }
		return (
			<section>
        <div className="jumbotron jumbotron-fluid">
          <div className="container">
            <h1 className="display-4">{tit}</h1>
            <p className="lead">{msj}</p>
          </div>
        </div>
			</section>
		)
	}
}


const mapStateToProps = (state, ownProps) => {
  return {
      productos: state.productos
    }
}

const mapDispatchToProps = dispatch => {
  return {
    guardaPago: (data) => {
      dispatch(guardaPago(data))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Resp)




// WEBPACK FOOTER //
// ./src/containers/resp.js